import { 
  GET_QUESTIONS_REQUEST, 
  GET_QUESTIONS_SUCCESS, 
  GET_QUESTIONS_FAILURE,
  UPDATE_QUESTION_STATUS_REQUEST,
  UPDATE_QUESTION_STATUS_SUCCESS,
  UPDATE_QUESTION_STATUS_FAILURE,
  CREATE_QUESTION_REQUEST,
  CREATE_QUESTION_SUCCESS,
  CREATE_QUESTION_FAILURE,
  UPDATE_QUESTION_REQUEST,
  UPDATE_QUESTION_SUCCESS,
  UPDATE_QUESTION_FAILURE,
  DELETE_QUESTION_REQUEST,
  DELETE_QUESTION_SUCCESS,
  DELETE_QUESTION_FAILURE,
} from '../actions/getQuestions';

const initialState = {
  ques_list_loading: false,
  ques_list_error: null,
  ques_list_data: null,
  update_question_status_loading:false,
  update_question_status_success:null,
  update_question_status_failure:null,
};

export default function getQuestionsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_QUESTIONS_REQUEST:
      return { ...state, ques_list_loading: true, ques_list_error: null };
    case GET_QUESTIONS_SUCCESS:
      return { ...state, ques_list_loading: false, ques_list_data: action.payload };
    case GET_QUESTIONS_FAILURE:
      return { ...state, ques_list_loading: false, ques_list_error: action.payload };
    default:
      return state;
  }
}